

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.bml', ['squid']).factory('$ApplyForBMLModel', function ($Model, $Api) {

        return $Model.extend('ApplyForBMLModel', {
            api: new $Api({
                uri: '/api/checkout/:id/cart',
                cache: true
            }),

            personalInformation: {
                day: '',
                month: '',
                year: '',
                natId: '',
                phone: {
                    telephone: '',
                    phoneType: ''
                }
            },

            billingAdrress: {
                phoneType: '',
                phoneNumber: ''
            }
        });
    }).factory('$BMLModel', function ($Model, $Api) {

        return $Model.extend('BMLModel', {
            api: new $Api({
                uri: '/api/bml',
                cache: false
            }),

            applicationStatus: function applicationStatus() {
                return this.application_status;
            },

            applicationId: function applicationId() {
                return this.application_id;
            }
        });
    }).factory('$BMLApplicationModel', function ($Model, $Api) {

        return $Model.extend('BMLApplicationModel', {
            api: new $Api({
                uri: '/api/bml/:application_id',
                cache: false
            })
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/bml/index.js
 ** module id = 374
 ** module chunks = 1
 **/